import { groq } from "next-sanity"

import { AppSettings } from "@/settings"

import { complaintOptionsProjection } from "../sanity/complaintOptions.projection"

export const queryComplaintCustomerClaims = {
  async complaintCustomerClaims(_parent, args, context, _info) {
    const lang = AppSettings.defaultLocale()
    const config = AppSettings.sanityConfigByLang(lang)
    const client = context.sanityClient
    client.config({ ...config, useCdn: (args.cdn = false) })

    try {
      const customerClaims = await client.fetch(groq`*[_type=="complaintCustomerClaims"] | order(name asc){
        ${complaintOptionsProjection()}
      }`)
      return customerClaims
    } catch (error) {
      throw new Error(error)
    }
  },
}
